export default __webpack_public_path__ + "static/equilibre_avatar_nathalie_uytterhaegen-5ea9359b949d893f3ec645d7e8733a38.png";